import { LayoutServiceContext, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import { env } from 'lib/env';

export const IsNRCTheme = ({ siteSpecificClass }: LayoutServiceContext): boolean =>
  !!siteSpecificClass?.includes('nrc-theme');

export const useIsNRC = (): boolean => {
  // Normalize input
  const { sitecoreContext } = useSitecoreContext();
  return IsNRCTheme(sitecoreContext); // NO SONAR - this is a deprecated method
};

const IsWebsite = (siteName: string): boolean => {
  const jssAppName = env.JSS_APP_NAME_NO_PREVIEW;
  return jssAppName.localeCompare(siteName, undefined, { sensitivity: 'accent' }) === 0;
};

export const IsNetworkSite = (): boolean => IsWebsite('NetworkResourceCenter');
export const IsRITN = (): boolean => IsWebsite('RITN');
export const IsNmdpSite = (): boolean => IsWebsite('NmdpSite');
export const IsNmdpConnectSite = (): boolean => IsWebsite('Beconnected');
export const DefaultGraphQLEndpoint = (): string => '/sitecore/api/graph/edge';
